<img [src]="image()" alt="" class="h-[12rem] w-full object-[75%_25%] object-cover"/>
<div class="px-4 py-8 bg-surface-100">
<h2 class="font-semibold text-2xl mb-4">{{title()}}</h2>
<p class="font-medium text-sm">{{description()}}</p>
</div>
